import { useTranslate } from '@tolgee/react';
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmModal = ({
  show,
  handleClose,
  handleConfirm,
  title,
  message,
  showNextButton
}) => {
  const { t } = useTranslate();
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {t('confirmModal.cancel')}
        </Button>
        <Button variant="primary" onClick={handleConfirm}>
          {showNextButton ? t('confirmModal.next') : t('confirmModal.continue')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
